module.exports = __webpack_public_path__ + "static/banner-image-2-52db500f7c7744b223e5c989fdd3c1fb.jpg";